<template>
  <div id="obituary-msg-list" @click="close">
    <div class="modal" @click.stop>
      <div class="close" :class="{ left: step === 'letter' }" @click="close">
        <!-- <v-icon>mdi-close-circle-outline</v-icon> -->
        <span>닫기</span>
      </div>
      <div>
        <button class="write-letter" v-if="step === 'letter'" @click="sendMsg">
          보내기
        </button>
        <button class="write-letter" v-else @click="step = 'letter'">
          글쓰기
        </button>
      </div>
      <div class="title d-flex">
        <h4>{{ step === "letter" ? "편지 쓰기" : "추모의 글" }}</h4>
      </div>
      <div v-if="step !== 'letter'">
        <div class="scrollable-container">
          <v-sheet
            class="message-sheet-item"
            v-for="(msg, idx) in obituaryMsgItem"
            :key="idx"
          >
            <div
              v-for="(item, i) in msg"
              :key="i"
              class="msg-card py-4 px-6 mt-3"
              style="
                width: 100%;
                height: auto;
                border: 1px solid #dadada;
                border-radius: 12px;
              "
            >
              <div>
                <h6 class="mb-1 bold-title d-flex">
                  {{ item.NAME }}
                  <v-spacer></v-spacer>
                  <button
                    v-if="item.USER_FLAG === 1"
                    @click="handleEditFlag(item)"
                  >
                    <img
                      src="../../assets/images/obituary/edit.svg"
                      alt="Edit"
                    />
                  </button>
                </h6>

                <p>{{ item.COMMENT_NO }}</p>
              </div>
            </div>
          </v-sheet>
        </div>
      </div>
      <div v-else>
        <h6>보내는 분</h6>
        <v-text-field
          v-model="NAME"
          solo
          flat
          dense
          hide-details
          type="text"
          color="main"
          placeholder="성함을 입력하세요"
        ></v-text-field>
        <h6 class="pt-2">비밀번호</h6>
        <v-text-field
          v-model="COMMENT_PASSWORD"
          hide-details
          solo
          flat
          dense
          :type="passwordFieldType"
          color="main"
          placeholder="수정 시 사용할 비밀번호를 입력"
          append-icon="mdi-eye"
          @click:append="togglePasswordVisibility"
        ></v-text-field>
        <h6 class="pt-2">추모 메시지</h6>
        <v-select
          v-model="COMMENT_NO"
          placeholder="추모 메시지를 선택할 수 있어요"
          :items="sampleCommentList"
          item-text="text"
          item-value="value"
          hide-details
          flat
          solo
          dense
          item-color="blue"
          class="order-input"
          style="padding: 4px 0px"
          attach
          :menu-props="{ top: false, offsetY: false }"
        >
        </v-select>
        <v-textarea
          v-model="COMMENT_NO"
          solo
          flat
          height="180px"
          counter="100"
          color="main"
          placeholder="삼가 고인의 명복을 빕니다"
        ></v-textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// import { REQUEST_OBITUARY_MSG_SEND } from "@/store/obituary"

export default {
  components: {},
  props: ["obituaryMsg", "letterListFlag"],
  data() {
    return {
      model: 0,
      step: null,
      NAME: null,
      COMMENT_NO: null,
      COMMENT_PASSWORD: "",
      passwordVisible: false,

      sampleCommentList: [
        {
          text: "삼가 故人의 冥福을 빕니다",
          value: "삼가 故人의 冥福을 빕니다",
        },
        {
          text: "삼가 고인의 명복을 빕니다",
          value: "삼가 고인의 명복을 빕니다",
        },
        {
          text: "謹 弔",
          value: "謹 弔",
        },
        {
          text: "極樂往生發願",
          value: "極樂往生發願",
        },
        {
          text: "극락왕생발원",
          value: "극락왕생발원",
        },
        {
          text: "천국에서 편히 쉬소서",
          value: "천국에서 편히 쉬소서",
        },
        {
          text: "하나님의 위로가 함께 하시길 빕니다",
          value: "하나님의 위로가 함께 하시길 빕니다",
        },
        {
          text: "주님의 위로와 소망이 함께 하기를 기원합니다",
          value: "주님의 위로와 소망이 함께 하기를 기원합니다",
        },
        {
          text: "직접입력",
          value: "",
        },
      ],
    };
  },
  computed: {
    obituaryMsgItem() {
      const tempList = [...this.obituaryMsg];
      const length = tempList.length;
      const n = 1;
      const divide =
        Math.floor(length / n) + (Math.floor(length % n) > 0 ? 1 : 0);
      const newArray = [];

      for (let i = 0; i <= divide; i++) {
        // 배열 0부터 n개씩 잘라 새 배열에 넣기
        newArray.push(tempList.splice(0, n));
      }

      return newArray.filter((v) => v.length);
    },
    ...mapGetters(["getObituary"]),

    passwordFieldType() {
      return this.passwordVisible ? "text" : "password";
    },
  },

  mounted() {
    if (this.letterListFlag === "regist") {
      this.step = "letter";
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },

    handleEditFlag(obituaryComment) {
      this.$emit("handleEditFlag", obituaryComment);
      this.$emit("close");
    },

    async sendMsg() {
      try {
        if (!this.NAME) {
          return alert("성함을 입력하여 주십시요");
        }

        if (!this.COMMENT_PASSWORD.trim()) {
          return alert("비밀번호를 입력하여 주십시요");
        }
        if (!this.COMMENT_NO) {
          return alert("내용을 입력하여 주십시요");
        }

        if (this.COMMENT_NO.length > 100) {
          alert("추모 메시지는 100자를 초과할 수 없습니다.");
          return;
        }

        const parameter = {
          EVENT_NO: this.getObituary.EVENT_NO,
          NAME: this.NAME,
          COMMENT_NO: this.COMMENT_NO,
          COMMENT_PASSWORD: this.COMMENT_PASSWORD,
          USER_FLAG: 1,
        };
        await this.$store
          .dispatch(`REQUEST_UPDATE_OBITUARY_COMMENT`, parameter)
          .then((res) => {
            if (!res) return;

            this.step = null;
            this.NAME = null;
            this.COMMENT_NO = null;
          });
      } catch (error) {
        console.error(error);
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
};
</script>

<style>
.scrollable-container {
  overflow-y: auto;
  max-height: 416px;
}
</style>
